import { getErrorDescription } from "@draftkings/sportsbook-common-utils";
import { telemetry } from "../constants";
import { getNavigatorConnectionData, safeString } from "../helpers";
export function formatCashOutTrackedException(error, start, method) {
    const e = error;
    const { statusCode, description, declineReason } = e;
    const { name, reason } = declineReason || {};
    return Object.assign({ traceTimeInMilliseconds: performance.now() - start, Method: method, ClientType: telemetry.clientType, StatusCode: safeString(statusCode), Description: safeString(description), DeclineReasonName: safeString(name), DeclineReason: safeString(reason), OriginalError: getErrorDescription(error), MyBetsVersion: telemetry.version }, getNavigatorConnectionData());
}
//# sourceMappingURL=formatCashOutTrackedException.js.map